import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { api } from '@shop/api-client'
import type { DraftListItem } from '../api/types'
import { draftStatusName, formatMoment, formatQty, sourceName } from '../ui/format'
import { Button, Empty, ErrorBanner, Panel, Spinner } from '@shop/ui'

/**
 * مسوّداتي — <b>وما يحتاج نظرًا يُرفع إلى الأعلى</b>.
 *
 * والافتراضُ «المفتوحة وحدَها»: الموظّفُ يفتح هذه الشاشةَ ليُنهي ما بدأه، لا
 * ليتصفّح ما اعتمده أمس. والمعتمَدةُ تبقى على بُعد ضغطة.
 */
export default function Drafts() {
  const [openOnly, setOpenOnly] = useState(true)

  const drafts = useQuery({
    queryKey: ['drafts', openOnly],
    queryFn: () => api<DraftListItem[]>(`/api/v1/intake/drafts?openOnly=${openOnly}&limit=100`),
  })

  return (
    <Panel
      title="مسوّداتي"
      actions={
        <Button onClick={() => setOpenOnly((current) => !current)}>
          {openOnly ? 'أظهر المنتهية أيضًا' : 'المفتوحة وحدَها'}
        </Button>
      }
    >
      {drafts.isPending && <Spinner />}
      {drafts.isError && <ErrorBanner error={drafts.error} />}

      {drafts.data?.length === 0 && (
        <Empty>
          لا مسوّدات. <Link className="underline underline-offset-4" to="/intake">ابدأ إدخالًا</Link>.
        </Empty>
      )}

      <ul className="space-y-2">
        {(drafts.data ?? []).map((draft) => (
          <li key={draft.id}>
            <Link
              to={`/drafts/${draft.id}`}
              className={`block rounded-md border px-3 py-2 hover:bg-surface ${
                draft.needsAttention ? 'border-warn/50 bg-warn/5' : 'border-line'
              }`}
            >
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <span className="text-sm font-medium">{draft.nameAr ?? '(بلا اسم)'}</span>
                <span className="tabular text-xs text-ink-soft" dir="ltr">
                  {draft.draftNo}
                </span>
              </div>

              <div className="mt-1 flex flex-wrap gap-x-3 text-xs text-ink-soft">
                <span>{draftStatusName(draft.status)}</span>
                <span>{sourceName(draft.source)}</span>
                <span className="tabular">كميّة: {formatQty(draft.qty)}</span>
                <span className="tabular">{formatMoment(draft.createdAt)}</span>
                {draft.needsAttention && <span className="text-warn">تنتظر نظرَك</span>}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </Panel>
  )
}
